export default{
  'overview_monthly_Monthly': 'Monthly',
  'overview_monthly_MAU': 'MAU',
  'overview_monthly_DAU': 'DAU',
  'overview_monthly_New': 'New',
  'overview_monthly_Avg_MAU': 'Avg.MAU',
  'overview_monthly_WAU': 'WAU',
  'overview_monthly_Avg_WAU': 'Avg.WAU',
  'overview_monthly_Avg_DAU': 'Avg.DAU',

  'overview_monthly_New_Users': 'New Users',
  'overview_monthly_Retention_Users': 'Retention Users',
  'overview_monthly_Return_Users': 'Return Users',

  // 卡片
  'overview_monthly_key_performance_metrics_explain_au': 'Monthly Active Users.Number of users who have logged in to the game during the statistical period (vopenid deduplicated).Date more than 1 month shows average MAU.',
  'overview_monthly_key_performance_metrics_explain_new': 'New Register Users.Total number of newly-registered users in the statistical period (vopenid deduplicated).Date more than 1 month shows sum new.',
  'overview_monthly_key_performance_metrics_explain_revenue': 'Count the total amount actually paid by the current players.Date more than 1 month shows sum revenue.',
  'overview_monthly_key_performance_metrics_explain_arpu': 'AverageRevenue Per Active Users.Consumption amount/Number of active users in the statistical period.<br/>Date more than 1 month shows average ARPU. Sum of consumption amount in the statistical period /Sum of active users in the statistical period.',
  'overview_monthly_key_performance_metrics_explain_payer': 'Number of paying users/Number of active users during the statistical period.<br/>Date more than 1 month shows average payer%.Sum of payers in the statistical period / Sum of active users in the statistical period.',
  'overview_monthly_key_performance_metrics_explain_m2': 'the retention rate of new register users on month 2 before the statistics month.<br/>M2：Number of retained users on month 2 from registration date / Number of new users on registration date.<br/>Registration month is month 1.<br/>Date more than 1 month shows average M2. Sum of retention users on month 2 in the statistical period / Sum of new register users in the statistical period.',

  'overview_monthly_Avg.Daily_New': 'Avg.Daily New',
  'overview_monthly_Month_Avg.DAU': 'Month Avg.DAU',
  'overview_monthly_Month_Avg.Revenue($)': 'Month Avg.Revenue({unit})',
  'overview_monthly_MAU_Breakdown': 'MAU Breakdown',
  'overview_monthly_Month_M2': 'M2',
  'overview_monthly_weighted_tab': 'Weighted M2/M3',
  'overview_monthly_Month_M2/3': 'M2/3',
  'overview_monthly_Month_M2(T-1)': 'M2(T-1)',
  'overview_monthly_Month_M3': 'M3',
  'overview_monthly_Month_M4': 'M4',
  'overview_monthly_MAU_Retention_Users': 'MAU Retention Users',
  'overview_monthly_MAU_Return_Users': 'MAU Return Users',
  'overview_monthly_avg_dau': 'Avg.DAU',
  'overview_monthly_Weighted_M2': 'Weighted M2',
  'overview_monthly_Weighted_M3': 'Weighted M3',
  'overview_monthly_Weighted_M2_short': 'WM2',
  'overview_monthly_Weighted_M3_short': 'WM3',
  'overview_monthly_Weighted_M4': 'Weighted M4',

  // TODO: 暂无
  'overview_month_retention_2': 'M2',
  'overview_month_retention_3': 'M3',
  'overview_month_Weighted_2': 'Weighted M2',
  'overview_month_Weighted_3': 'Weighted M3',
  'overview_monthly_Last_Year': 'SMLY',
  'overview_monthly_This_Month': 'This Month',


  'overview_monthly_Dowload_Date': 'DATE',
  'overview_monthly_Dowload_country': 'Country',
  'overview_monthly_Dowload_Region': 'Region',
  'overview_monthly_Dowload_Revenue': 'Revenue',
  'overview_monthly_Dowload_netRevenue': 'Revenue After Refund & Tax',
  'overview_monthly_Dowload_MTX_Revenue': 'In-Game Revenue',
  'overview_monthly_Dowload_Unit': 'Full Game Units',
  'overview_monthly_Dowload_New': 'New',
  'overview_monthly_Dowload_Share': 'Share',
  'overview_monthly_Dowload_Zone': 'Zone',
  'overview_monthly_Dowload_Channel': 'Channel',
  'overview_monthly_Dowload_PlatForm': 'PlatForm',
}
